import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import dataFile from './data.js'
import { MatDialog } from '@angular/material/dialog';
import { AdminService } from 'src/app/admin/services/admin.service';

@Component({
  selector: 'app-detailed-registration',
  templateUrl: './detailed-registration.component.html',
  styleUrls: ['./detailed-registration.component.scss']
})
export class DetailedRegistrationComponent implements OnInit {
  // submitBtnText = 'NEXT';
  submitBtnText = 'SUBMIT';
  // DraftBtnText = 'DraftBtnText';
  atRegisterForm: boolean = true;

  heading = dataFile[0];          //All headings from data file
  inputDataList = dataFile[1];    // All data objects from data file
  panelListItem: any = '';
  queryParams: any;
  isDisableForm: any;
  cseOption: {}[];
  couponData: any;
  appliedCouponDetails: any;
  showMenu:boolean = false;

  constructor(private authService: AuthService, private router: Router, public dialog: MatDialog, private adminService: AdminService,
    private route: ActivatedRoute,) {
    // this.authService.pinCodeList().subscribe((response: any) => {
    //   console.log("Pincode List", response);
    // },
    //   (error) => {
    //     console.log(error.error.message);
    //     Swal.fire('Error', `${error.error.message}`, 'error')
    //   }
    // )
    let params = '';
    this.adminService.getCSEListing(params, sessionStorage.getItem("token")).subscribe((response: any) => {
      // console.log(response);
      this.cseOption = response?.data.map((obj) => {
        return ({ name: obj.name, value: obj.id })
        // return ({ name: obj.name, value: obj.name })     //Temporary
      })
    })

    this.queryParams = this.route.snapshot.queryParams;
  }

  ngOnInit(): void {
    // ngAfterViewInit()

    setTimeout(() => {
      // console.log(this.cseOption);
      this.inputDataList[2][3].option = this.cseOption;
    }, 2000)
  }

  submitData(response) {
    // let couponObj = { couponId: response[0]?.coupon_id, total_discounted_amount: response[0]?.totalDiscountedAmount }
    // this.authService.setcouponDetails(couponObj);

    let detailRegisterData = response[0].value;
    detailRegisterData = { ...detailRegisterData, coupon_id: response[0].coupon_id, finalSubmit: true }
    let token = sessionStorage.getItem("token");
    this.authService.detailRegisterSubmit(detailRegisterData, token).subscribe((response: any) => {
      console.log("OTP DATA", response);
      // if (response.code == 200) {
      sessionStorage.setItem('isProfileUpdated', 'true');
      Swal.fire('Success', 'Data Submitted Successfully', 'success').then(() => {
        // this.router.navigateByUrl('welcome-login');
        this.router.navigateByUrl('login/payment');
      })

      // const dialogRef = this.dialog.open(RegisterTermsConditionComponent, {
      //   width: '500px',
      // });
      sessionStorage.setItem("facility name", detailRegisterData['facility_name']);   //To update name

    },
      (error) => {
        console.log(error.error.message);
        Swal.fire('Error', `${error.error.message}`, 'error')
      }
    )
  }

  formButtonResEvent(response) {
    console.log("inside detailed form", response);
    if (response[0].status == 'VALID') {
      // Swal.fire('Sucess', 'Form DATA is VALID', 'success')
      this.submitData(response)
      console.log('response', response);
    }
  }

  panelListItemRes(event) {
    // console.log('inside detail', event);
    this.panelListItem = event;
  }

  isDisableFormRes(event) {
    this.isDisableForm = event;
  }

  couponAppliedRes(couponData) {
    console.log('coupon Id in detail register', couponData);
    this.couponData = couponData;
  }

  couponDetailsRes(couponDetails) {
    this.appliedCouponDetails = couponDetails;
  }

  showSideMenu() {
    this.showMenu = !this.showMenu;
  }
}
